import { getQueryParam, buildQueryString } from '../../helpers';

export const getMetaContent = key => {
    const els = document.getElementsByTagName('meta');
    const el = [...els].find(el => el.name === key);

    return el ? el.content : null;
};

export const csrfToken = () => getMetaContent('csrf-token');

const jsonMimeType = 'application/json';

function updateOptions(options) {
    const update = { 
        ...options,
        credentials: 'same-origin',
        headers: new Headers({
            'Accept': jsonMimeType,
            'Content-Type': jsonMimeType,
        })
    };
    
    if(update.method !== 'GET'){
        update.headers.append('X-CSRF-TOKEN', decodeURIComponent(csrfToken()));
    }

    return update;
}

export default function fetcher(url, options) {
    let queryParams = { token: window.accessToken, nd: getQueryParam('nd') }

    if (Object.keys(queryParams).length) {
        const queryString = buildQueryString(queryParams);

        if (url.includes('?')) {
            url = `${url}&${queryString}`;
        } else {
            url = `${url}?${queryString}`;
        }
    }

    return fetch(url, updateOptions(options));
}